
import isEmpty from 'lodash/isEmpty'

import { fetchSEOTags } from '@http/endpoints'
import Tags from '@product/components/Tags'

import translations from './Tags.translations'

export default {
  components: {
    Tags,
  },

  data() {
    return {
      tags: [],
    }
  },

  async fetch() {
    // This call must not be blocking, the rendered list will be updated when the data are received.
    await this.$store
      .dispatch('http/request', {
        request: fetchSEOTags,
        queryParams: {
          model: 'landing',
          pk: this.$route.params.landingId,
        },
      })
      .then(({ payload: tags = [] } = {}) => {
        this.tags = tags
      })
      .catch(() => {
        // Nothing to do.
      })
  },

  computed: {
    translations: () => translations,

    shouldDisplayTags() {
      return !isEmpty(this.tags)
    },
  },
}
